import { render, staticRenderFns } from "./HeadSelect.vue?vue&type=template&id=524f64e6"
import script from "./HeadSelect.vue?vue&type=script&lang=js"
export * from "./HeadSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports